// VerificationProcess.js
import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Users, CheckCircle, FileCheck } from 'lucide-react';

const VerificationProcess = () => {
  const steps = [
    {
      id: 1,
      icon: FileText,
      title: "Intake & Scoping",
      description: "Tell us your objective, country, timelines, and documents. Choose Standard or Rush."
    },
    {
      id: 2,
      icon: Users,
      title: "Human Outreach & Fieldwork",
      description: "We contact source-of-truth institutions (registrars, HR desks, landlords, associations) and, where needed, dispatch a field agent. We aim for two independent corroborations for each claim."
    },
    {
      id: 3,
      icon: CheckCircle,
      title: "Dual Review & Sign-off",
      description: "Every case is reviewed by a supervisor before release."
    },
    {
      id: 4,
      icon: FileCheck,
      title: "Report Delivery",
      description: "You receive a signed PDF with: source details, contact method, date/time, summary of responses, and artifacts (photos, email headers, call log snippets). For addresses, we attach a field evidence pack with geo/time stamps. Outcome labels: Verified / Inconclusive / Discrepant."
    }
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack">
            How our verification works
          </h2>
        </motion.div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <motion.div
                key={step.id}
                className="text-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.15 }}
                viewport={{ once: true }}
              >
                {/* Icon */}
                <div className="flex flex-col items-center mb-6">
                  <div className="w-16 h-16 bg-acYellow rounded-full flex items-center justify-center mb-4">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default VerificationProcess;
